import { Box, TextField, Typography, Divider, InputAdornment, Autocomplete } from "@mui/material";
import { Business as BusinessIcon, LocationOn as LocationIcon } from "@mui/icons-material";
import { formatCNPJ, ESTADOS_BRASIL } from "../../../utils/formatters";

const CompanyForm = ({ formData, errors, handleChange }) => {
  const handleCNPJChange = (e) => {
    const formatted = formatCNPJ(e.target.value);
    handleChange("cnpj", formatted);
  };

  const handleStateChange = (event, newValue) => {
    handleChange("originState", newValue ? newValue.sigla : "");
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Dados da Empresa
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", md: "row" } }}>
          <TextField
            fullWidth
            label="Nome da Empresa *"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          
          <Autocomplete
            fullWidth
            options={ESTADOS_BRASIL}
            getOptionLabel={(option) => `${option.nome} (${option.sigla})`}
            value={ESTADOS_BRASIL.find(estado => estado.sigla === formData.originState) || null}
            onChange={handleStateChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Estado *"
                error={!!errors.originState}
                helperText={errors.originState}
                required
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationIcon />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Box>
        
        <TextField
          fullWidth
          label="CNPJ"
          value={formData.cnpj}
          onChange={handleCNPJChange}
          error={!!errors.cnpj}
          helperText={errors.cnpj}
          placeholder="12.345.678/0001-90"
          inputProps={{ maxLength: 18 }}
        />
      </Box>
    </Box>
  );
};

export default CompanyForm;